var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1325_14339)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 1.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7266 22.7878C10.9834 22.8178 11.2447 22.8331 11.5096 22.8331C13.0475 22.8331 14.4629 22.3141 15.5864 21.4435C14.15 21.4173 12.9377 20.4788 12.52 19.1891C12.7204 19.227 12.926 19.2473 13.1375 19.2473C13.4369 19.2473 13.7269 19.2076 14.0024 19.1335C12.5007 18.8353 11.3692 17.5232 11.3692 15.9504C11.3692 15.9367 11.3692 15.9231 11.3695 15.9096C11.8121 16.1527 12.3182 16.2987 12.8563 16.3156C11.9755 15.7335 11.396 14.7399 11.396 13.6136C11.396 13.0187 11.5578 12.4611 11.8404 11.9817C13.4594 13.9456 15.8782 15.238 18.6064 15.3734C18.5504 15.1358 18.5213 14.888 18.5213 14.6336C18.5213 12.8409 19.9911 11.3875 21.804 11.3875C22.7481 11.3875 23.6012 11.7817 24.2001 12.4126C24.9478 12.267 25.6503 11.9968 26.2845 11.6249C26.0394 12.3829 25.519 13.019 24.8412 13.4208C25.5052 13.3423 26.1379 13.1678 26.7266 12.9096C26.2865 13.5606 25.7299 14.1324 25.0886 14.5901C25.0949 14.7293 25.0981 14.8693 25.0981 15.01C25.0981 19.2997 21.7963 24.2462 15.7585 24.2462C13.9047 24.2462 12.1793 23.7088 10.7266 22.7878Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1325_14339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.64dcb3c0561c9654a96c0d117931576b.svg";
export { ForwardRef as ReactComponent };